// removed by extract-text-webpack-plugin
module.exports = {"status":"Status-module__status___6053J"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Status/Status.module.scss
// module id = 322
// module chunks = 0 1